import React, {useEffect, useState} from 'react';
import {useFormContext} from 'react-hook-form';

const ListCountries = ({name = 'country', required = false, initialSelect}) => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);

  const {register, setValue, watch, formState: {errors}} = useFormContext();

  const selected = watch(name);

  useEffect(() => {
    fetchCountries();
  }, []);

  useEffect(() => {
    if (initialSelect !== undefined && countries.length > 0) {
      setValue(name, initialSelect);
    }
  }, [initialSelect, countries, name, setValue]);

  async function fetchCountries() {
    setLoading(true);
    try {
      const url = process.env.REACT_APP_APIURL + 'countries';
      const response = await fetch(url, {
        headers: {Accept: 'application/json, text/plain, */*'},
      });
      const result = await response.json();

      setCountries(
          result.data.map((country) => ({
            value: country.id,
            label: country.name,
          })),
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <select
        className={`form-control ${errors[name] ? 'is-invalid' : ''}`}
        {...register(name, {
          required: required ? 'Please select an option' : false,
        })}
        value={selected || ''}
        onChange={(e) => setValue(name, e.target.value)}
      >
        <option value="">Select country{required && ' *'}</option>
        {loading && <option disabled>Loading...</option>}
        {countries.map((c) => (
          <option key={c.value} value={c.label}>
            {c.label}
          </option>
        ))}
      </select>
      {errors[name] && (
        <div className="invalid-feedback">{errors[name]?.message}</div>
      )}
    </>
  );
};

export default ListCountries;
